'use client';

import { c as _c } from "react/compiler-runtime";
import { RoleSwitcher } from '@/app/components/RoleSwitcher';
import { SuggestionButton } from '@/app/components/SuggestionButton';
import { UserMenu } from '@/app/components/UserMenu';
import jmtLogoUrl from '@/public/JMT-Long.png';
import nexusLogoUrl from '@/public/Nexus.png';
import lightspeedLogoUrl from '@/public/PPT-Long.png';
import MenuIcon from '@mui/icons-material/Menu';
import AppBar from '@mui/material/AppBar';
import Box from '@mui/material/Box';
import IconButton from '@mui/material/IconButton';
import Toolbar from '@mui/material/Toolbar';
import Image from '@shared/components/SafeImage';
import { SIDEBAR_WIDTH, TOP_BAR_HEIGHT } from '@shared/theme';
import { usePathname } from 'next/navigation';
import { type FC } from 'react';
interface TopBarProps {
  isMenuOpen: boolean;
  onToggleMenu: () => void;
  env: 'development' | 'production' | 'test';
  currentRole?: string;
  jmtAccess?: boolean;
  qmtAccess?: boolean;
}
const lightspeedLogo = ['/sheets', '/sites', '/workstations', '/material_types', '/engineers', '/suggestions'];
const nexusLogo = ['/'];
export const TopBar: FC<TopBarProps> = t0 => {
  const $ = _c(33);
  const {
    isMenuOpen,
    onToggleMenu,
    env,
    currentRole: t1,
    jmtAccess: t2,
    qmtAccess: t3
  } = t0;
  const currentRole = t1 === undefined ? "USER" : t1;
  const jmtAccess = t2 === undefined ? false : t2;
  const qmtAccess = t3 === undefined ? false : t3;
  const path = usePathname();
  const useHomeLogo = nexusLogo.some(segment => path === segment);
  const useLightspeedLogo = lightspeedLogo.some(segment_0 => path.includes(segment_0));
  let t4;
  if ($[0] !== isMenuOpen) {
    t4 = theme => ({
      backgroundColor: theme.palette.getContrastText(theme.palette.primary.main),
      height: TOP_BAR_HEIGHT,
      zIndex: theme.zIndex.drawer + 1,
      transition: theme.transitions.create(["width", "margin"], {
        easing: theme.transitions.easing.sharp,
        duration: theme.transitions.duration.leavingScreen
      }),
      ...(isMenuOpen && {
        marginLeft: SIDEBAR_WIDTH,
        width: `calc(100% - ${SIDEBAR_WIDTH}px)`,
        transition: theme.transitions.create(["width", "margin"], {
          easing: theme.transitions.easing.sharp,
          duration: theme.transitions.duration.enteringScreen
        })
      })
    });
    $[0] = isMenuOpen;
    $[1] = t4;
  } else {
    t4 = $[1];
  }
  let t5;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = {
      justifyContent: "space-between",
      position: "relative"
    };
    $[2] = t5;
  } else {
    t5 = $[2];
  }
  let t6;
  if ($[3] !== isMenuOpen) {
    t6 = isMenuOpen && {
      visibility: "hidden"
    };
    $[3] = isMenuOpen;
    $[4] = t6;
  } else {
    t6 = $[4];
  }
  let t7;
  if ($[5] !== t6) {
    t7 = {
      marginRight: 5,
      ...t6
    };
    $[5] = t6;
    $[6] = t7;
  } else {
    t7 = $[6];
  }
  let t8;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = <MenuIcon />;
    $[7] = t8;
  } else {
    t8 = $[7];
  }
  let t9;
  if ($[8] !== onToggleMenu || $[9] !== t7) {
    t9 = <IconButton color="primary" onClick={onToggleMenu} edge="start" sx={t7}>{t8}</IconButton>;
    $[8] = onToggleMenu;
    $[9] = t7;
    $[10] = t9;
  } else {
    t9 = $[10];
  }
  let t10;
  if ($[11] === Symbol.for("react.memo_cache_sentinel")) {
    t10 = {
      position: "absolute",
      left: "50%",
      transform: "translateX(-50%)"
    };
    $[11] = t10;
  } else {
    t10 = $[11];
  }
  let t11;
  if ($[12] !== currentRole || $[13] !== env || $[14] !== jmtAccess || $[15] !== qmtAccess) {
    t11 = env !== "production" && <RoleSwitcher currentRole={currentRole} jmtAccess={jmtAccess} qmtAccess={qmtAccess} env={env} />;
    $[12] = currentRole;
    $[13] = env;
    $[14] = jmtAccess;
    $[15] = qmtAccess;
    $[16] = t11;
  } else {
    t11 = $[16];
  }
  const t12 = useHomeLogo ? nexusLogoUrl : useLightspeedLogo ? lightspeedLogoUrl : jmtLogoUrl;
  let t13;
  if ($[17] === Symbol.for("react.memo_cache_sentinel")) {
    t13 = {
      aspectRatio: 1,
      width: 750,
      height: 80
    };
    $[17] = t13;
  } else {
    t13 = $[17];
  }
  let t14;
  if ($[18] !== t12) {
    t14 = <Image src={t12} priority={true} alt="Lightspeed" style={t13} />;
    $[18] = t12;
    $[19] = t14;
  } else {
    t14 = $[19];
  }
  let t15;
  if ($[20] !== t11 || $[21] !== t14) {
    t15 = <Box display="inline-flex" alignItems="center" gap={2} sx={t10}>{t11}{t14}</Box>;
    $[20] = t11;
    $[21] = t14;
    $[22] = t15;
  } else {
    t15 = $[22];
  }
  let t16;
  if ($[23] === Symbol.for("react.memo_cache_sentinel")) {
    t16 = <SuggestionButton />;
    $[23] = t16;
  } else {
    t16 = $[23];
  }
  let t17;
  if ($[24] !== env) {
    t17 = <Box display="inline-flex">{t16}<UserMenu env={env} /></Box>;
    $[24] = env;
    $[25] = t17;
  } else {
    t17 = $[25];
  }
  let t18;
  if ($[26] !== t15 || $[27] !== t17 || $[28] !== t9) {
    t18 = <Toolbar sx={t5}>{t9}{t15}{t17}</Toolbar>;
    $[26] = t15;
    $[27] = t17;
    $[28] = t9;
    $[29] = t18;
  } else {
    t18 = $[29];
  }
  let t19;
  if ($[30] !== t18 || $[31] !== t4) {
    t19 = <AppBar sx={t4}>{t18}</AppBar>;
    $[30] = t18;
    $[31] = t4;
    $[32] = t19;
  } else {
    t19 = $[32];
  }
  return t19;
};